import { Helmet } from "react-helmet-async"
import { HotelCheckInOutReportsList } from "../../../HotelCheckInOutReports"

export default function HotelCheckInOutReportsListPage() {
	return (
		<>
			<Helmet>
				<title>Hotel Check In/Outs</title>
			</Helmet>
			<HotelCheckInOutReportsList />
		</>
	)
}
